import canUseDOM from 'helpers/canUseDOM';

export const getCuratedPortfolioToken = uri =>
  canUseDOM ? window.localStorage.getItem(`curated-portfolio - ${uri}`) : null;
export const setCuratedPortfolioToken = (uri, token) =>
  canUseDOM && window.localStorage.setItem(`curated-portfolio - ${uri}`, token);
